import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  POST_DATA_STORE,
  DELETE_STORE,
} from 'actions/AddOrEditStore/actionTypes';
import {} from 'actions/AddOrEditStore';
import StoreApi from 'service/storeApi';
import { pushNotification } from 'utils/notifications';
import { showModalStore } from 'actions/AddOrEditStore';

function* postDataStore(action) {
  try {
    const response = yield call(StoreApi.post, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, 'error', 'TOP_CENTER', 2000);
      } else {
        yield put(showModalStore(null));
        pushNotification(response.data.Message, 'success', 'TOP_CENTER', 2000);
      }
    } else {
      pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
    }
  } catch (error) {}
}

function* watchGetRequest() {
  yield takeLatest(POST_DATA_STORE, postDataStore);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
